export default __webpack_public_path__ + "static/media/navbar-logo.db0a961c.png";